export default "__VITE_ASSET__BtTktmkD__"